const api = `${process.env.PUBLIC_URL}/api`;
export const SearchResultApi = `${api}/searchResult.json`;
export const ContactsApi = `${api}/contacts.json`;
export const TasksApi = `${api}/tasks.json`;
export const UserCardsApi = `${api}/user-cards.json`;
export const BookmarkApi = `${api}/bookmark.json`;
export const TodoApi = `${api}/todo.json`;
export const EmailApi = `${api}/email.json`;
export const ChatMembersApi = `${api}/chatMembers.json`;
export const ChatApi = `${api}/chats.json`;
export const ChatContactApi = `${api}/chatContacts.json`;
export const ProductApi = `${api}/product.json`;
export const JobSearchApi = `${api}/jobSearch.json`;
